export enum ActionType {
  /** Set current page */
  SET_PAGE = 'SET_PAGE',
  /** Set current stack */
  SET_PAGE_STACK = 'SET_PAGE_STACK',
  /** Take a page out of stack */
  DECREMENT_PAGE = 'DECREMENT_PAGE',
  /** Merge phone number with current user state */
  SET_PHONE_NUMBER = 'SET_PHONE_NUMBER',
  /** Merge user data object with current state */
  MERGE_USER_DATA = 'MERGE_USER_DATA',
  /** Set the geolocation data */
  INITIALIZE_GEOLOCATION = 'INITIALIZE_GEOLOCATION',
  /** Request user login */
  LOGIN_USER = 'LOGIN_USER',
  LOGIN_USER_LOADING = 'LOGIN_USER_LOADING',
  LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS',
  LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE',
  /** Request user register */
  REGISTER_USER = 'REGISTER_USER',
  REGISTER_USER_LOADING = 'REGISTER_USER_LOADING',
  REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS',
  REGISTER_USER_FAILURE = 'REGISTER_USER_FAILURE',
  /** Setup a partial user given their userId */
  SETUP_INCOMPLETE_USER = 'SETUP_INCOMPLETE_USER',
  SETUP_INCOMPLETE_USER_LOADING = 'SETUP_INCOMPLETE_USER_LOADING',
  SETUP_INCOMPLETE_USER_SUCCESS = 'SETUP_INCOMPLETE_USER_SUCCESS',
  SETUP_INCOMPLETE_USER_FAILURE = 'SETUP_INCOMPLETE_USER_FAILURE',
  /** Logout firebase user */
  LOGOUT_USER = 'LOGOUT_USER',
  /** Clear the user error */
  CLEAR_USER_ERROR = 'CLEAR_USER_ERROR',
  /** Register a user with a temporary name and password */
  TEMPORARY_REGISTER_USER = 'TEMPORARY_REGISTER_USER',
  TEMPORARY_REGISTER_USER_LOADING = 'TEMPORARY_REGISTER_USER_LOADING',
  TEMPORARY_REGISTER_USER_SUCCESS = 'TEMPORARY_REGISTER_USER_SUCCESS',
  TEMPORARY_REGISTER_USER_FAILURE = 'TEMPORARY_REGISTER_USER_FAILURE',
  /** Replace temp user name and password with real values. */
  FINISH_TEMPORARY_REGISTER_USER = 'FINISH_TEMPORARY_REGISTER_USER',
  FINISH_TEMPORARY_REGISTER_USER_LOADING = 'FINISH_TEMPORARY_REGISTER_USER_LOADING',
  FINISH_TEMPORARY_REGISTER_USER_SUCCESS = 'FINISH_TEMPORARY_REGISTER_USER_SUCCESS',
  FINISH_TEMPORARY_REGISTER_USER_FAILURE = 'FINISH_TEMPORARY_REGISTER_USER_FAILURE',
  /** Set the pricing currency */
  SET_CURRENCY = 'SET_CURRENCY',
  /** Set the coupon code to be applied to the purchase */
  SET_COUPON_CODE = 'SET_COUPON_CODE',
  /** Set the trial & subscription plans for which prices should be fetched. */
  SET_AVAILABLE_PLANS = 'SET_AVAILABLE_PLANS',

  FETCH_PRICES_LOADING = 'FETCH_PRICES_LOADING',
  FETCH_PRICES_SUCCESS = 'FETCH_PRICES_SUCCESS',
  FETCH_PRICES_FAILURE = 'FETCH_PRICES_FAILURE',
  /** Set the plan, trial plan and trial period of the item to be purchased. */
  SET_PAYMENT_PLAN = 'SET_PAYMENT_PLAN',
  /** Set the trial plan selected to purchase */
  SET_SELECTED_TRIAL_PLAN = 'SET_SELECTED_TRIAL_PLAN',
  CONFIRM_CHECKOUT = 'CONFIRM_CHECKOUT',
  CREATE_CHECKOUT = 'CREATE_CHECKOUT',
  CREATE_CHECKOUT_LOADING = 'CREATE_CHECKOUT_LOADING',
  CREATE_CHECKOUT_SUCCESS = 'CREATE_CHECKOUT_SUCCESS',
  CREATE_CHECKOUT_FAILURE = 'CREATE_CHECKOUT_FAILURE',
  SETUP_EXPRESS_PAY = 'SETUP_EXPRESS_PAY',
  SETUP_EXPRESS_PAY_LOADING = 'SETUP_EXPRESS_PAY_LOADING',
  SETUP_EXPRESS_PAY_SUCCESS = 'SETUP_EXPRESS_PAY_SUCCESS',
  SETUP_EXPRESS_PAY_FAILURE = 'SETUP_EXPRESS_PAY_FAILURE',
  PAYMENT_LOADING = 'PAYMENT_LOADING',
  PAYMENT_SUCCESS = 'PAYMENT_SUCCESS',
  PAYMENT_FAILURE = 'PAYMENT_FAILURE',
  /** Set the addon to be added to the selected plan  */
  SET_ADDON = 'SET_ADDON',
  /** Set whether the addon was successully purchased  */
  SET_ADDON_PURCHASED = 'SET_ADDON_PURCHASED',
  /** Set referral information */
  SET_REFERRAL_INFO = 'SET_REFERRAL_INFO',
  /** Set the PAP score result after completing the Patient Assistance Program */
  SET_PAP_SCORE_RESULT = 'SET_PAP_SCORE_RESULT',
  /** Restore store state from persistence (e.g. localStorage) */
  RESTORE_STORE = 'RESTORE_STORE',
  /** Send password reset email */
  RESET_PASSWORD = 'RESET_PASSWORD',
  RESET_PASSWORD_LOADING = 'RESET_PASSWORD_LOADING',
  RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE',
  /** Grant US 65+ free access */
  GRANT_US_65_PLUS_ACCESS = 'GRANT_US_65_PLUS_ACCESS',
  GRANT_US_65_PLUS_ACCESS_LOADING = 'GRANT_US_65_PLUS_ACCESS_LOADING',
  GRANT_US_65_PLUS_ACCESS_SUCCESS = 'GRANT_US_65_PLUS_ACCESS_SUCCESS',
  GRANT_US_65_PLUS_ACCESS_FAILURE = 'GRANT_US_65_PLUS_ACCESS_FAILURE',
}
